import React from 'react';
import {HorizontalCardProps} from './types';
import styled from 'styled-components';
import {COLORS, ComponentMStyling, ComponentTextStyle, ComponentXSStyling} from '../../styles';
import {LinearProgress} from '../../LinearProgress';
import {Tag} from '../../Tag';

export const HorizontalCardBodyContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
`;

export const HorizontalCardBodyTitle = styled.div`
  ${ComponentMStyling(ComponentTextStyle.Bold, COLORS.black)}
  .disabled & {
    color: ${COLORS.neutral_500};
  }
`;

export const HorizontalCardBodyDescription = styled.div`
  ${ComponentXSStyling(ComponentTextStyle.Regular, COLORS.neutral_600)}
`;

export const HorizontalCardBodyTagsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 4px 0;
  gap: 4px;
`;

type Props = Pick<HorizontalCardProps, 'title' | 'description' | 'progress' | 'tags'>;

export const HorizontalCardBody: React.FunctionComponent<Props> = ({
                                                                     title,
                                                                     description,
                                                                     progress,
                                                                     tags,
                                                                   }) => {

  return (
    <HorizontalCardBodyContainer>
      <HorizontalCardBodyTitle>{title}</HorizontalCardBodyTitle>
      {description && <HorizontalCardBodyDescription>{description}</HorizontalCardBodyDescription>}
      {
        tags &&
        <HorizontalCardBodyTagsContainer>{tags.map((tag, index) => (
          <Tag key={index} label={tag.label} variant={tag.variant} icon={tag.icon}/>))}
        </HorizontalCardBodyTagsContainer>
      }
      {progress && <LinearProgress value={progress.value} max={progress.max}/>}
    </HorizontalCardBodyContainer>
  )
};
